import PageLoader from '@/common/service/flow/page-loader';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { loadSelectByPersist } from '@/common/service/plan-data-mapper';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { VIEWS } from '@/views/bridge';
import Flow from '@/flows/flow';
import { addToCartByCategoryAndBillingCycle } from '@/common/service/flow/utils';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { UpdateTypes, updatePlansCheckout } from '@/common/service/checkout-utils';
import store from '@/store/index';
import { parseConsumptionCode } from '@/plans/EVENT_SAAS/helper/parse';

const loadDefaultSelectByQuery = () => {
  return (planList = []) => {
    const { from } = pageConfig || {};
    const targetCategory = from;
    const targetPlanType = getPlanTypeByCategory(from);
    const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);

    if (!hasSelected) {
      addToCartByCategoryAndBillingCycle(planList, targetPlanType, targetCategory)
      return planList;
    }

    return planList;
  };
};


async function initShoppingCartForSwitch(state) {
  const { persist } = state;

  const { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService();

  const loader = new PageLoader(planMap);
  loader.decorate('loadByPersist', loadSelectByPersist(persist));
  loader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery(boughtPlans));

  const planList = await loader.dispatch();

  return {
    allPlanMap,
    boughtPlans,
    subscriptions,
    freeTrialPlans,
    planMapFlat: planList,
  };
}
function checkoutForSwitch() {
  const planList = store.getters.getSelectedPlans.map(item => {
    if(item.isPPA) {
      const { plan_code, attendees } = parseConsumptionCode(item.plan_code)
      return {
        quantity: attendees,
        planCode: plan_code,
        oldPlanCode: pageConfig.oldPlanCode,
      }
    }
    return {
      quantity: item.cartInfo.selected_number,
      planCode: item.plan_code,
      oldPlanCode: pageConfig.oldPlanCode,
    }
  })

  return updatePlansCheckout(planList, UpdateTypes.SWITCH);
}

export default {
  [flowTypes.switch]: class extends Flow {
    view() {
      return VIEWS.COMPOUND;
    }
    init() {
      return initShoppingCartForSwitch(...arguments);
    }
    submit() {
      return checkoutForSwitch();
    }
  }
};
